import memoize from 'lodash/memoize';
import compose from 'recompose/compose';
import when from 'recompose/branch';
import withProps from 'recompose/withProps';
import renderNothing from 'recompose/renderNothing';
import { connect } from 'react-redux';
import logger from 'src/logger';
import { getItems, isCartEmpty, isCartPending } from '../../../store/selectors/cart';
import CartItems from './CartItems';
import withCart from '../../hocs/withCart';
import formatPrismicData from '../../hocs/formatPrismicData';
import { replaceTextWithValues } from 'src/common/utils/text-replace';

import {
  trackInBasket,
} from '../../../analytics/category/cart';

const track = memoize((itemId, productId) => {
  trackInBasket(productId);
});

const trackItems = (items = []) => {
  items.forEach(item => {
    try {
      track(item.id, item.format.product.id);
    } catch (error) {
      logger.error(error);
    }
  });
};

const enhance = compose(
  withCart,
  formatPrismicData,
  connect(
    (state, props) => {
      const cart = getItems(state);
      return {
        items: cart,
        title: replaceTextWithValues(props.title, { quantity: cart.length || 1 }),
        isCartEmpty: isCartEmpty(state),
        isCartPending: isCartPending(state),
      };
    }
  ),
  when(props => props.isCartEmpty && !props.isCartPending, renderNothing),
  withProps(props => {
    if (!props.isCartPending && !props.isCartEmpty) {
      trackItems(props.items);
    }
  })
);

export default enhance(CartItems);



// WEBPACK FOOTER //
// ./src/client/js/view/components/CartItems/index.js